import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominationUp({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 12 12"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.995 1.75a.75.75 0 01.744.648l.006.102v4a.75.75 0 01-1.493.102l-.007-.102V4.284L7.563 7.391a.75.75 0 01-.782.229l-.103-.04L4.23 6.437 1.6 9.954a.75.75 0 01-.955.211l-.094-.06A.75.75 0 01.34 9.15l.06-.093L3.393 5.05a.75.75 0 01.809-.272l.11.041 2.484 1.161L9.155 3.25h-2.16a.75.75 0 01-.743-.648L6.245 2.5a.75.75 0 01.649-.743l.101-.007h4z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominationUp.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominationUp.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNominationUp svgRef={ref} {...props} />);
export default ForwardRef;
